<div class="empty-list" [ngClass]="{ small: small }" *ngIf="isEmpty">
  <mat-icon svgIcon="empty_list" class="small-icon"></mat-icon>
  <p class="main-emp small-text">{{ "general.empty_list" | translate }}</p>
</div>
